var moneyFormat = "";

$(document).ready(function () {
  
    var mobileSettings = {
        themeBreakpoint: 1000,
        isSearchBoxDetachable: true,
        isHeaderLinksWrapperDetachable: true,
        doesDesktopHeaderMenuStick: true,
        displayGoToTop: true,
        hasStickyNav: true,
        selectors: {
            menuTitle: ".menu-title",
            headerMenu: ".header-menu",
            closeMenu: ".close-menu",
            movedElements: ".header, .main-slider, .responsive-nav-wrapper, .master-wrapper-content, .footer",
            sublist: ".header-menu .sublist-wrap",
          	goToTop: "#goToTop",
            overlayOffCanvas: ".overlayCanvas",
            searchBox: ".search-box",
            searchBoxBefore: "#topcartlink",
            navWrapper: ".responsive-nav-wrapper",
            headerLinksWrapper: ".header-links-wrapper",
          	headerLinksWrapperMobileInsertAfter: '.responsive-nav-wrapper',
          	headerLinksWrapperDesktopPrependTo: '.header-line',
            shoppingCartLink: ".shopping-cart-link"
        }
    }

    if(getAndroidVersion() === false || parseFloat(getAndroidVersion()) !== 2.3){
        $('body').addClass('notAndroid23');
    }
    else{
        $('body').addClass('android23');
    }    

    if($('body').hasClass('template-index')){
        $('.post-body img').parent('p').addClass('blog-img-wrapper');
        $('p').not('blog-img-wrapper').addClass('blog-text-wrapper');
    }

    initResponsiveTheme(mobileSettings, true, true);
});

function getCartTotalPrice(price){
  	return Shopify.formatMoney(price, moneyFormat);
}